import { Appointment, AppointmentID } from "./Appointment";
import { Car, CarID } from "./Car";
import { CommunicationAgreement } from "./CheckIn";
import { CommunicationSetting } from "./CommunicationSetting";
import { Customer, CustomerID } from "./Customer";
import { CommunicationResult } from "./CustomerCommunication";
import { DealerLocationID } from "./DealerLocation";
import { User, UserID } from "./User";

export type DeskCommunicationID = number;

export type DeskCommunicationEventID = number;

export type DeskAgreedInterventionID = number;

export type DeskCheckInDeclinedInterventionID = number;

export enum DESK_COMMUNICATION_STATUSES {
  DeskCheckInSent = 1,
  DeskCheckInReceived = 2,
  DeskCheckInFailedToOpen = 3,
  DeskCheckInOpened = 4,
  DeskCheckInAnswered = 5,
  DeskCheckInClosed = 6
}

export enum DESK_COMMUNICATION_EVENTS {
  DeskCheckInSent = 1,
  DeskCheckInReceived = 2,
  DeskCheckInFailedToOpen = 3,
  DeskCheckInOpened = 4,
  DeskCheckInCanceled = 5,
  DeskCheckInAnswered = 6
}

export interface DeskCommunication {
  created_on: string;
  updated_on: string;
  id: DeskCommunicationID;
  receptionist_key: string; // Key given and used by the Receptionist
  status: DESK_COMMUNICATION_STATUSES; // Current status of this DeskCommunication
  is_checking_out: boolean; // If the communication is done when the appointment status is car ready or quality check, this is set to true
  correct_phone: string; // Phone number entered by the customer
  correct_email: string; // Email entered by the customer
  customer_id: CustomerID | null; // Customer who this DeskCommunication is for
  appointment_id: AppointmentID; // Appointment from which this DeskCommunication originated from
  car_id: CarID; // Car from which the Appointment is for
  receptionist_id: UserID; // Receptionist who last interacted with this DeskCommunication
  dealer_location_id: DealerLocationID; // DealerLocation from which the Appointment is from
  customer?: Customer; // Customer associated with the desk communication
  appointment?: Appointment; // Appointment associated with the desk communication
  car?: Car; // Car associated with the appointment for this desk communication
  user?: User; // Receptionist, whom the receptionist key belongs to
  is_receptionist?: boolean; // The Receptionist is currently interacting with this DeskCommunication
  events?: DeskCommunicationEvent[]; // Desk communication events for the desk communication
  agreed_interventions?: DeskAgreedIntervention[]; // Slice of agreed interventions
  declined_interventions?: DeskDeclinedIntervention[]; // Slice of declined interventions
  agreements?: CommunicationAgreement[]; // DeskAgreements that have been agreed
  results?: CommunicationResult[]; // CommunicationResults that the customer was sent in desk check in
  settings?: CommunicationSetting; // Settings for this CustomerCommunication
  user_tablet_mode_key?: string; // Key if it is user tablet mode
}

export interface DeskCommunicationEvent {
  created_on: string;
  updated_on: string;
  id: DeskCommunicationEventID;
  type: DESK_COMMUNICATION_EVENTS; // Type of the DeskCommunicationEvent
  customer_name: string; // Name of the customer
  customer_signature: string; // Signature of the customer
  desk_communication_id: DeskCommunicationID; // Identifier of the desk communication
}

export interface DeskAgreedIntervention {
  created_on: string;
  id: DeskAgreedInterventionID;
  title: string; // Title of the agreed intervention
  description: string; // Description of the agreed intervention
  price: number; // Price of the agreed intervention
  vat: number | null; // VAT of the agreed intervention
  desk_communication_id: DeskCommunicationID; // Identifier of the desk communication
}

export interface DeskDeclinedIntervention {
  created_on: string;
  id: DeskCheckInDeclinedInterventionID;
  title: string; // Title of the declined intervention
  description: string; // Description of the declined intervention
  price: number; // Price of the declined intervention
  vat: number | null; // VAT of the declined intervention
  desk_communication_id: DeskCommunicationID; // Identifier of the desk communication
}
